import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRemoveSectionMutation = createMutationHook(
  ShopRendererDraftApiClient.removeSection,
  {
    mutationKey: ['removeSection'],
  },
)
